import script from "./MyWorkOrderUnComment.vue?vue&type=script&setup=true&lang=js"
export * from "./MyWorkOrderUnComment.vue?vue&type=script&setup=true&lang=js"

import "./MyWorkOrderUnComment.vue?vue&type=style&index=0&id=611c5199&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-611c5199"]])

export default __exports__